import { z } from "zod";

export const ENVIRONMENT_VARIABLES_SCHEMA = z.object({
	VITE_API_URL: z.string().url().min(1),
	VITE_NODE_ENV: z.enum(["development", "production"]),
	VITE_TINY_MCE: z.string().optional(),
});
